import { useState } from "react";
import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Logo } from "../common/Logo";
import { LanguageSwitcher } from "../common/LanguageSwitcher";
import { MobileMenu } from "./MobileMenu";

const navLinks = [
  { to: "/features", labelKey: "nav.features" },
  { to: "/downloads", labelKey: "nav.downloads" },
  { to: "/future", labelKey: "nav.future" },
  { to: "/known-issues", labelKey: "nav.knownIssues" },
  { to: "/changelog", labelKey: "nav.changelog" },
  { to: "/docs", labelKey: "nav.docs" },
  { to: "/dashboard", labelKey: "nav.dashboard" },
];

export function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const { t } = useTranslation();

  return (
    <header className="fixed top-0 left-0 right-0 h-16 bg-dark-bg/80 backdrop-blur-md border-b border-dark-border z-50">
      <div className="max-w-7xl mx-auto px-4 h-full flex items-center justify-between">
        <Logo />

        <nav className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <NavLink
              key={link.to}
              to={link.to}
              className={({ isActive }) =>
                `text-sm font-medium transition-colors ${
                  isActive ? "text-warm-50" : "text-warm-500 hover:text-warm-100"
                }`
              }
            >
              {t(link.labelKey)}
            </NavLink>
          ))}
          <LanguageSwitcher />
        </nav>

        <button
          className="md:hidden p-2 text-warm-100 hover:text-warm-50"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          aria-label="Toggle menu"
        >
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            {mobileMenuOpen ? (
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            ) : (
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M4 6h16M4 12h16M4 18h16"
              />
            )}
          </svg>
        </button>
      </div>

      <MobileMenu isOpen={mobileMenuOpen} onClose={() => setMobileMenuOpen(false)} />
    </header>
  );
}
